<template>
  <div class="bg-0 flx-col fs-12 c-d7 ft-container">
    <div class="flx-row">
      <div
        class="bdr pdlr-20"
        :class="index==4?'nobdr':''"
        v-for="(item,index) in $t('Layout.navList')"
        :key="index"
      >
        <p class="csr-pt" @click="navigate(index)">{{item}}</p>
      </div>
      <!-- <div class="bdr pdlr-20">
        <p class="csr-pt">商城</p>
      </div>
      <div class="bdr pdlr-20">
        <p class="csr-pt">陈列馆</p>
      </div>
      <div class="bdr pdlr-20">
        <p class="csr-pt">新闻</p>
      </div>
      <div class="pdlr-20">
        <p class="csr-pt">联系我们</p>
      </div>-->
    </div>
    <!-- <div>©2019 KING ARTS INTERNATIONAL LIMITED ALL RIGHTS RESERVED. 粤ICP备17051615</div> -->
  </div>
</template>
<script>
export default {
  methods: {
    navigate(e) {
      switch (e) {
        case 0:
          this.$router.push({
            path: "/"
          });
          break;
        case 1:
          this.$router.push({
            path: "/shop"
          });
          break;
        case 2:
          this.$router.push({
            path: "/exhibition"
          });
          break;
        case 3:
          this.$router.push({
            path: "/news"
          });
          break;
        case 4:
          this.$router.push({
            path: "/contact"
          });
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-0 {
  padding: 3.125rem 0;
  width: 100%;
  .flx-row {
    margin-bottom: 1.25rem;
  }
  .bdr {
    border-right: 0.0625rem solid #d7d7d7;
  }
  .nobdr {
    border-right: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footerbar/footerbar.vue